type MaybePromise<T> = T|PromiseLike<T>;
export type EntryPoint = {default: (...args: any[]) => MaybePromise<void|(() => MaybePromise<void>)>};
type EntryPointUnload = () => MaybePromise<void>;


const entrypoints = new Map<string, (...args: any[]) => Promise<EntryPointUnload>>();


export function registerEntryPoint(name: string, loader: () => Promise<EntryPoint>) {
    let _current_reset = async () => {};
    entrypoints.set(name, async (...args: any[]) => {
        const [_, {default: runner}] = await Promise.all([_current_reset(), loader()]);
        const unloader = await runner(...args) || (async () => {});
        let unloadPromise: Promise<void>|null = null;
        _current_reset = async () => {
            unloadPromise ||= Promise.resolve(unloader()).then(() => {});
            await unloadPromise;
        };
        return _current_reset;
    });
}

(window as any)["startEntrypoint"] = function startEntrypoint(name: string, ...args: any[]) {
    if (!entrypoints.has(name)) return Promise.resolve(async () => {});
    const ep = entrypoints.get(name)!;
    return ep(...args).catch((error) => {
        console.error(error);
        return async () => {};
    });
}

class EntrypointElement extends HTMLElement {
    static observedAttributes = ["name", "args"];

    #connected = false;
    #epoch = 0;
    #unload: EntryPointUnload = async () => {};

    connectedCallback() {
        this.#connected = true;
        this.#reload();
    }

    disconnectedCallback() {
        this.#connected = false;
        this.#epoch++;
        Promise.resolve(this.#unload()).catch(console.error);
        this.#unload = async () => {};
    }

    attributeChangedCallback() {
        this.#reload();
    }

    #reload() {
        if (!this.#connected) return;

        this.#epoch++;
        Promise.resolve(this.#unload()).catch(console.error);
        this.#unload = async () => {};

        const epoch = this.#epoch;
        const name = this.getAttribute("name") || "";
        const args = JSON.parse(this.getAttribute("args") || "[]");

        (window as any).startEntrypoint(name, ...args).then((unload: EntryPointUnload) => {
            if (!this.#connected || this.#epoch !== epoch) {
                unload();
                return;
            }
            this.#unload = unload;
        });
    }
}

window.customElements.define("tmv2-entrypoint", EntrypointElement);
